<template>
  <woot-modal :show="show" :on-close="handleClose" :header-title="$t('IMAGE_LIBRARY.EDIT_ITEM')">
    <div class="space-y-4 p-4">
      <div class="flex items-start gap-4 rounded-md p-2">
        <div class="w-24 h-24 rounded overflow-hidden bg-gray-100 flex-shrink-0">
          <img :src="item?.thumb_url || item?.file_url" class="w-full h-full object-cover" />
        </div>
        <div class="flex-1 space-y-3">
          <div>
            <woot-input
              v-model="form.title"
              :label="$t('IMAGE_LIBRARY.FIELDS.TITLE')"
              :required="true"
              :placeholder="$t('IMAGE_LIBRARY.FIELDS.TITLE_PLACEHOLDER')"
              :error="v$.form.title.$error ? $t('IMAGE_LIBRARY.FIELDS.TITLE_ERROR') : ''"
              :class="{ error: v$.form.title.$error }"
              @blur="v$.form.title.$touch"
            />
          </div>
          <div>
            <FormLabel
              :label="$t('IMAGE_LIBRARY.FIELDS.DESCRIPTION')"
              :required="false"
              :has-error="false"
            />
            <TextArea
              v-model="form.description"
              name="image-item-description"
              :placeholder="$t('IMAGE_LIBRARY.FIELDS.DESCRIPTION_PLACEHOLDER')"
              :max-length="1000"
              show-character-count
              auto-height
              :resize="true"
              :min-height="'120px'"
              rows="6"
              :disabled="isSubmitting"
            />
          </div>
        </div>
      </div>

      <div class="flex justify-center gap-2 pt-2">
        <button class="input-base bg-slate-100 dark:bg-slate-700 !text-slate-700 dark:!text-slate-300 rounded-lg" :disabled="isSubmitting" @click="handleClose">{{ $t('GENERAL.CANCEL') }}</button>
        <button class="input-base bg-grass-500 text-white rounded-lg" :is-loading="isSubmitting" :disabled="!form.title" @click="save">{{ $t('GENERAL.SAVE') }}</button>
      </div>
    </div>
  </woot-modal>
  
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

export default {
  name: 'EditItemModal',
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    show: { type: Boolean, default: false },
    accountId: { type: [String, Number], required: true },
    libraryId: { type: [String, Number], required: true },
    item: { type: Object, default: null },
  },
  emits: ['close', 'saved'],
  components: { TextArea },
  data() {
    return {
      form: { title: '', description: '' },
      isSubmitting: false,
    }
  },
  validations: {
    form: {
      title: { required },
    },
  },
  watch: {
    item: {
      handler(v) {
        this.form.title = v?.title || ''
        this.form.description = v?.description || ''
      },
      immediate: true,
    },
    show(v) {
      if (!v) return
      this.form.title = this.item?.title || ''
      this.form.description = this.item?.description || ''
    }
  },
  methods: {
    handleClose() {
      this.v$.$reset();
      this.$emit('close');
    },
    async save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      
      try {
        this.isSubmitting = true
        const payload = { title: this.form.title, description: this.form.description }
        await window.axios.put(`/api/v1/accounts/${this.accountId}/image_libraries/${this.libraryId}/image_items/${this.item.id}`, payload)
        this.$emit('saved')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>



